// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Subsonic__Artists from "./artists.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(param) {
  const params = {};
  return Fx.Monad_syntax.let$star(Subsonic__Utils.makeRequest({
    _method: "rest/getArtists",
    params: params
  }, Subsonic__Artists.of_json), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.artists
    };
  }));
}

export {
  make,
}
/* No side effect */
